import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../env";
import { ExpandProvider, useExpand } from "../hooks/useExpanded";
import Title from "../components/Title";

export default function ExplorTrack() {

    const navigate = useNavigate()
    const { id } = useParams()
    const [track, setTrack] = useState(undefined)

    useEffect(() => {
        if (id) {
            api.get(`tracks/${id}`)
                .then(res => setTrack(res.data))
                .catch(err => {})
        }
    }, [id])

    return(<div className="standard-padding">
        <Title className={'v-spacer-xs'} back={() => navigate('../')}>{track?.displayName} <span className="lighter neutral">Track</span></Title>
        <p className="card-body v-spacer-l hi-spacer-xxs">{track?.description}</p>
        <hr className="o-50 v-spacer-xl"/>
        <ExpandProvider>
            {track && track.chapters.map(chapter => <Chapter chapter={chapter} />)}
        </ExpandProvider>
    </div>)
}

function Chapter({chapter}) {

    const navigate = useNavigate()
    const { expanded, handleExpand } = useExpand(chapter.id)

    const explore = (id) => navigate(`spark/${id}`)

    return(<div className="two-columns gap-s v-spacer-xxl" style={{gridTemplateColumns: '300px 1fr'}}>
        <div className="dashed-card columns gap-xs padding clickable" onClick={() => handleExpand(chapter.id)} style={{background: 'rgba(var(--primary-dark), 10%)'}}>
            <p className="card-title">{chapter.title}</p>
            {!expanded && <p className="card-label neutral">Click to Expand</p>}
            {expanded && <p className="card-body showing">{chapter.theme}</p>}
        </div>
        {!expanded && <div className="standard-padding-xs flex columns justify-center">
            <p className="card-body"><span className="bold">Activities: </span> {chapter.activities.map(it => it.title).join(', ')}</p>
            <p className="card-body"><span className="bold">Sparks: </span> {chapter.sparks.map(it => it.displayName).join(', ')}</p>
        </div>}
        {expanded && <div className="standard-padding-xs">
            <p className="card-title bold v-spacer-xxs">Activities</p>
            {chapter.activities.map(item => <p className="card-body"><span className="bold primary">{item.title}</span> - {item.description}</p>)}
            <p className="card-title bold vi-spacer-m v-spacer-xxs">Sparks</p>
            {chapter.sparks.map(item =>
                <div className="flex center gap-xs" key={item?.id}>
                     <p className="card-body"><span className="bold primary">{item.displayName}</span> - {item.description}</p>
                    <button className="outline scale-s" onClick={() => explore(item.sparkId)}>Explore</button>
                </div>
            )}
        </div>}
    </div>)
}